// @flow

import React from 'react';
import type { Node } from 'react';
import { breakpointsToArray } from '../../../helpers';
import { Flex } from '../../grid';
import Text from './labelText.styled';

type Props = {|
  children: Node,
|};

export default ({ children, ...props }: Props) => (
  <Flex width={breakpointsToArray({ default: 1, sm: 6 / 12 })} flexShrink={0} py="0.5em" {...props}>
    <Text>{children}</Text>
  </Flex>
);
